import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Collapse } from 'antd';
import moment from 'moment';

import * as BaseType from 'modules/basisType/hooks';

import * as Grid from 'components/Grid';

import classes from './LexDataList.module.scss';
import Label from 'components/Label';

const LexDataList = ({ items = [], title, renderExtra }) => {
  const { t } = useTranslation();

  const [activeKey, setActiveKey] = useState();

  const baseType = BaseType.useAll();

  const legalBasis = lexId => baseType.items.find(item => item.lexId == lexId);

  if (!items.length) return null;

  return (
      <Collapse className={classes.basisList} activeKey={activeKey} onChange={setActiveKey}>
        {items.map(item => (
          <Collapse.Panel
            key={item.id}
            className={classes.basisListItem}
            showArrow
            header={
              <div className={classes.basisListItemHeader}>
                <div dangerouslySetInnerHTML={{ __html: item?.content?.uz }} />
              </div>
            }
          >
            <Grid.Row gutter={[24, 24]} align="bottom">
              <Grid.Col xl={24}>
                <Label title={t('field_doc_name')}>
                  <p>{item.docName || '--'}</p>
                </Label>
              </Grid.Col>

              {renderExtra?.(item)}

              <Grid.Col xl={8}>
                <Label title={t('field_basis_number')}>
                  <p>{item.docNumber || '--'}</p>
                </Label>
              </Grid.Col>

              <Grid.Col xs={8}>
                <Label title={t('field_basis_type')}>
                  <p>{legalBasis(item.lexId)?.name?.uz || '--'}</p>
                </Label>
              </Grid.Col>

              <Grid.Col xs={8}>
                <Label title={t('field_basis_date')}>
                  <p>
                    {item.basisDate?.split('T')[0]
                     ? moment(item.basisDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
                     : '--'}
                  </p>
                </Label>
              </Grid.Col>

              <Grid.Col xs={8}>
                <Label title={t('field_accept_date')}>
                  <p>{item.acceptDate || '--'}</p>
                </Label>
              </Grid.Col>

              <Grid.Col xs={8}>
                <Label title={t('field_change_date')}>
                  <p>{item.changeDate || '--'}</p>
                </Label>
              </Grid.Col>
            </Grid.Row>
          </Collapse.Panel>
        ))}
      </Collapse>
  );
};

export default LexDataList;
